export const CHART_COLORS = {
  teal: '#0D9488',
  amber: '#D97706',
  red: '#DC2626',
  blue: '#2563EB',
  purple: '#7C3AED',
  pink: '#E11D48',
  cyan: '#0891B2',
  emerald: '#059669',
  orange: '#EA580C',
  indigo: '#4F46E5',
  slate: '#64748B',
} as const;

export const CHART_PALETTE = [
  CHART_COLORS.teal, CHART_COLORS.blue, CHART_COLORS.amber,
  CHART_COLORS.purple, CHART_COLORS.pink, CHART_COLORS.cyan, CHART_COLORS.orange,
];

export const SEGMENT_COLORS = {
  'Price-Sensitive Buyers': CHART_COLORS.teal,
  'Low-Interest Prospects': CHART_COLORS.red,
  'Budget Seekers': CHART_COLORS.amber,
  'Overall': CHART_COLORS.blue,
} as const;

export const PNL_GRADIENT = {
  loss: '#991B1B',
  breakeven: '#E2E6ED',
  profit: '#065F46',
} as const;

export const GRID_PROPS = {
  strokeDasharray: '3 3',
  stroke: 'var(--color-grid-stroke)',
  vertical: false,
};

export const X_AXIS_PROPS = {
  stroke: 'var(--color-axis-stroke)',
  tick: { fill: 'var(--color-axis-tick)', fontSize: 11, fontWeight: 500 },
  tickLine: { stroke: 'var(--color-axis-stroke)' },
};

export const Y_AXIS_PROPS = {
  stroke: 'var(--color-axis-stroke)',
  tick: { fill: 'var(--color-axis-tick)', fontSize: 11, fontWeight: 500 },
  tickLine: { stroke: 'var(--color-axis-stroke)' },
};

export const TOOLTIP_STYLE = {
  contentStyle: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E6ED',
    borderRadius: '12px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.04)',
    padding: '12px 16px',
  },
  itemStyle: { color: '#1A1D23', fontSize: '13px', padding: '2px 0' },
  labelStyle: { color: '#5A6170', fontSize: '11px', fontWeight: 600, marginBottom: '4px' },
};

export const LEGEND_PROPS = {
  wrapperStyle: { color: '#5A6170', fontSize: '11px', paddingTop: '8px' },
};

export function getPnLColor(value: number, min: number, max: number): string {
  const baseR = 238, baseG = 240, baseB = 244;

  if (value === 0) return `rgb(${baseR}, ${baseG}, ${baseB})`;

  if (value < 0) {
    const t = Math.min(Math.abs(value) / Math.abs(min), 1);
    const r = Math.round(baseR + t * (220 - baseR));
    const g = Math.round(baseG + t * (38 - baseG));
    const b = Math.round(baseB + t * (38 - baseB));
    return `rgb(${r}, ${g}, ${b})`;
  }

  const t = Math.min(value / max, 1);
  const r = Math.round(baseR + t * (5 - baseR));
  const g = Math.round(baseG + t * (150 - baseG));
  const b = Math.round(baseB + t * (105 - baseB));
  return `rgb(${r}, ${g}, ${b})`;
}
